<template>
  <div class="wrapper">
    <MyHeader></MyHeader>
    <div class="content">
      <router-view></router-view>
    </div>
    <MyFooter class="footer"></MyFooter>
  </div>
</template>
<script>
import MyFooter from "@/components/MyFooter";
import MyHeader from "@/components/MyHeader";
export default {
  name: 'Index',
  components: {
    MyHeader,
    MyFooter
  },
  data () {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  background-image: url("../../assets/img/background.jpg");
  background-size: 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
  min-width: 1250px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.content {
  flex: 1 0 auto;
}
.footer {
  margin-top: auto;
  flex-shrink: 0;
}
</style>
